import { EmojiRenderer } from "@circle-react-shared/EmojiRenderer";
import type { Space } from "@circle-react/types";
import type { MouseEvent } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useThemeContext } from "@/react/providers/Theme";

export interface SpaceListProps {
  handleSpace: (event: MouseEvent<HTMLButtonElement>, id: number) => void;
  spaces: Space[];
}

export const SpaceList = ({ spaces, handleSpace }: SpaceListProps) => {
  const { currentAppearance } = useThemeContext();

  return (
    <ul className={anchorClassNames("react-space-selector-dropdown__list")}>
      {spaces.map(space => (
        <li key={space.id}>
          <button
            type="button"
            className="w-full text-left"
            onClick={e => handleSpace(e, space.id)}
          >
            <EmojiRenderer
              className={anchorClassNames(
                "react-space-selector-dropdown__icon",
              )}
              emoji={space.emoji ?? "⬜️"}
              appearance={currentAppearance}
              customEmojiUrl={space.custom_emoji_url}
              customEmojiDarkUrl={space.custom_emoji_dark_url}
            />
            <span
              className={anchorClassNames(
                "react-space-selector-dropdown__name",
              )}
            >
              {space.name}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
};
